import Crud from './crud'
import { upload_file } from '@/commons/hpod';
import { sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
var crud = new Crud('hscode', 'Mã HS');

const state = {
    ...crud.state,
    selected: {}
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    import_file({ commit }, formData) {
        commit("setLoading", { loading: true });
        upload_file(crud.endpoint, res => {
            commit("setLoading", { loading: false });
            if(res.status == 202) {
                sendErrorNotice(res.data.reason)                    
            }
            else {
                refreshResource();
            }
            
        }, Vue.http, formData, this.state.authentication.token, 'import');
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};